import { useMutation } from '@apollo/client/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import { Button } from '~/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/components/ui/card'
import { GQL_VERIFY_ACCOUNT } from '~/gql/auth/auth'

function ValidAccount() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  const token = searchParams.get('token')
  const email = searchParams.get('email')

  useEffect(() => {
    if (!token || !email) {
      navigate('/')
    }
  }, [token, email, navigate])

  const [verify, { loading, called: isCalled }] = useMutation(GQL_VERIFY_ACCOUNT)

  const onVerify = async () => {
    try {
      const { data } = await verify({
        variables: {
          email: email!,
          token: token!,
        },
      })
      if (data && data.verifyEmail) {
        toast.success(t('valid.account.success'))
        setTimeout(() => {
          navigate('/')
        }, 2000)
      } else {
        toast.error(t('valid.account.failed'))
      }
    } catch {
      toast.error(t('bad.server-login.message'))
    }
  }

  if (loading) {
    return (
      <p className="text-center">
        {t('common.loading')}
        {' '}
        ...
      </p>
    )
  }

  return (
    <div className="flex w-screen min-h-dvh flex-col items-center justify-center p-5">
      <Card className="sm:w-md w-full">
        <CardHeader>
          <CardTitle className="text-2xl">{t('account.validate')}</CardTitle>
          <CardDescription>
            {t('account.validate.confirmation')}
          </CardDescription>
        </CardHeader>
        <CardContent>

          <Button
            type="submit"
            className="w-full"
            disabled={isCalled}
            onClick={onVerify}
          >
            <p className="text-background-foreground">{t('common.validate')}</p>
          </Button>

          <div className="mt-4 text-center text-sm">
            <a
              onClick={() => navigate('/')}
              className="underline underline-offset-4 cursor-pointer"
            >
              {t('login.return-message')}
            </a>
          </div>

        </CardContent>
      </Card>
    </div>
  )
}

export default ValidAccount
